import { PLUSS_ALL } from '../config/featureFlags';

/**
 * Single source of truth for Pluss entitlement.
 * Later: sync from parent account / purchase — never open payment UI to the child.
 */
export function hasPluss(): boolean {
  return PLUSS_ALL;
}
